import { getApiConfig } from "../../../settings/api";
import { AxiosResponse } from "axios";
import { Action } from "redux-saga";
import { call, CallEffect, PutEffect } from "redux-saga/effects";

export interface Fetch {
    callback: (success: boolean, code?: string) => void;
}

export interface RequestTicketsAction {
    type: string;
    payload: Fetch;
}

export default function* requestTickets({
    payload,
}: RequestTicketsAction): Generator<
    CallEffect<unknown> | PutEffect<Action>,
    void,
    AxiosResponse
> {
    try {
        const data = {};

        const { apiInstance } = getApiConfig(true);
        const response = yield call(apiInstance.post, `/internalwebapi/v1/vehicle-debts/internal-payment-receipt`, data);

        const payloadData = Array.isArray(response?.data) ? response?.data : response?.data?.data;

        if (payloadData) {
            yield call(payload.callback, true, payloadData);
        } else {
            yield call(payload.callback, false, "error");
        }

    } catch (error) {
        yield call(payload.callback, false, "timeout");
    }
}